export default __webpack_public_path__ + "static/media_01-338a87dafcb90e2ce2d528856880445b.jpg";